import { InactiveIngredientContentModel } from './inactiveIngredientContentModel';

export class InactiveIngredientAdminModel {
  public inactiveIngredientId: number;
  public name: string;
  public currentInactviveToMedStrength: string;
  public inactiveIngredientContent: Array<InactiveIngredientContentModel>;
}